module.exports = __webpack_public_path__ + "static/media/marker-o.9d912fd9.svg";